'use strict'

import APIList from "./apiList";

const Filters = {
    el: null,
    params: {},
    init: function () {
        Filters.el = document.querySelector('.c-filters');
        if (Filters.el) {
            Filters.updateFiltersFromUrl();
        }
    },
    handleChoices: function () {
        function debounce(func, delay) {
            let timeout;
            return function (...args) {
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(this, args), delay);
            };
        }

        function updateParams(key, value) {
            if (value) {
                Filters.params[key] = value;
            } else {
                delete Filters.params[key];
            }
        }

        const searchBarReset = Filters.el.querySelector('.searchBar button[type="button"]');
        if (searchBarReset) {
            searchBarReset.addEventListener('click', () => {
                const input = searchBarReset.closest('.searchBar').querySelector('input');
                if (input) {
                    input.value = "";
                    input.dispatchEvent(new Event('change', {bubbles: true}));
                }
            });
        }

        const filters = Filters.el.querySelectorAll('input[type="text"], input[type="radio"], select');
        if (filters.length > 0) {
            filters.forEach(filter => {
                if (filter.type === 'radio') {
                    Filters.handleRadioFilter(filter, updateParams);
                } else {
                    let eventList = ["change", "keyup", "paste", "input"];
                    eventList.forEach(event => {
                        filter.addEventListener(event, debounce(() => {
                                Filters.processFilter(filter, updateParams);
                            },
                            filter.type === 'text' ? 800 : 50
                        ));
                    });
                }
            });
        }
    },

    handleRadioFilter: function (filter, updateParams) {
        filter.addEventListener('change', () => {
            if (filter.checked) {
                Filters.processFilter(filter, updateParams);
            }
        });

        const formGroup = filter.closest('.form-group');
        if (formGroup && formGroup.dataset.noapi === "true") {
            filter.addEventListener('click', () => {
                setTimeout(() => {
                    if (filter.checked) {
                        Filters.processFilter(filter, updateParams);
                    }
                }, 10);
            });
        }
    },

    processFilter: function (filter, updateParams) {
        const name = filter.name;
        const checkedRadio = Filters.el.querySelectorAll(`input[name="${name}"]:checked`);
        const value = filter.type === 'radio' ?
            (checkedRadio.length > 0 ? Array.from(checkedRadio).map(cb => cb.value).join(',') : '')
            : filter.value;

        if ((filter.id === 'keyword') && filter.value.length < 3 && filter.value.length !== 0) {
            return;
        }

        // client side
        if (filter.closest('.form-group') && filter.closest('.form-group').dataset.noapi === "true") {
            const items = document.querySelectorAll('[data-filter]');
            items.forEach(item => {
                const itemFilters = item.getAttribute("data-filter").split(",");
                if (value === "*" || value === "" || itemFilters.includes(value)) {
                    // Show the item
                    item.classList.remove("hide");
                    item.classList.add("show");
                } else {
                    // Hide the item
                    item.classList.remove("show");
                    item.classList.add("hide");
                }
            });
            return;
        }

        // server side
        updateParams(name, value);
        Filters.updateUrl();
    },
    updateUrl: function () {
        // On prend l’URL courante
        let currentUrl = window.location.href.split('?')[0];

        // On supprime /page/N/ si présent
        currentUrl = currentUrl.replace(/\/page\/\d+\//, '/');

        // On reconstruit proprement l’URL
        const url = new URL(currentUrl, window.location.origin);

        // Ajout des paramètres de filtre
        Object.keys(Filters.params).forEach(key => {
            if (Filters.params[key].length > 0) {
                url.searchParams.set(key, Filters.params[key]);
            } else {
                url.searchParams.delete(key);
            }
        });

        // Toujours remettre la pagination à 1
        url.searchParams.set('paged', 1);

        // Push dans l’historique
        window.history.pushState({}, '', decodeURIComponent(url.toString()));

        // Recharge les datas
        APIList.getDatas();
    },
    updateFiltersFromUrl: function () {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.forEach((value, key) => {
            const elements = Filters.el.querySelectorAll(`[name="${key}"]`);
            elements.forEach(element => {
                if (element.type === 'radio') {
                    const values = value.split(',');
                    values.forEach(val => {
                        if (element.id === val) {
                            element.checked = true;
                        }
                    });
                } else {
                    element.value = value;
                }
            });

            Filters.params[key] = value;
        });
        if(document.querySelector('.tpl-publications')){
                Filters.activateFirstFilter();
        }
        if (urlParams.size > 0) {
            APIList.getDatas();
        }
        Filters.handleChoices();
    },
    activateFirstFilter: function() {
        const clientSideGroups = Filters.el.querySelectorAll('.form-group[data-noapi="true"]');

        clientSideGroups.forEach(group => {
            const firstRadio = group.querySelector('input[type="radio"]:first-of-type');
            if (firstRadio && !firstRadio.checked) {
                firstRadio.checked = true;

                const name = firstRadio.name;
                const value = firstRadio.value;

                const items = document.querySelectorAll('[data-filter]');
                items.forEach(item => {
                    const itemFilters = item.getAttribute("data-filter").split(",");
                    if (value === "*" || itemFilters.includes(value)) {
                        item.classList.remove("hide");
                        item.classList.add("show");
                    } else {
                        item.classList.remove("show");
                        item.classList.add("hide");
                    }
                });
            }
        });
    }
}

export default Filters;